import { render, staticRenderFns } from "./searchGame.vue?vue&type=template&id=9570cf86&scoped=true"
import script from "./searchGame.vue?vue&type=script&lang=js"
export * from "./searchGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9570cf86",
  null
  
)

export default component.exports